module.exports = __webpack_public_path__ + "static/gc-inventory-reporting-demo-cropped.2735c15c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/pages/gc-inventory-reporting-demo-cropped.mp4
// module id = ./src/pages/gc-inventory-reporting-demo-cropped.mp4
// module chunks = 199769300672215